import { useDevOnly } from '@/composables/useDevOnly';

export default [
    {
        path: 'lens',
        name: 'lens',
        redirect: { name: 'lens-builder' },
        component: () => import('../views/LensPage.vue'),
        beforeEnter: () => {
            const { isBnSupport } = useDevOnly();
            if (!isBnSupport()) return { name: 'home' };
        },
        children: [
            {
                path: 'builder/:lensId?',
                name: 'lens-builder',
                meta: { label: 'New lens' },
                component: () => import('../views/lens/LensBuilderPage.vue'),
                props: true,
            },
            {
                path: ':lensId',
                name: 'lens-view',
                component: () => import('../views/lens/LensViewPage.vue'),
                props: true,
            },
        ],
    },
];
